import { Component } from 'react'

class Debounce extends Component {
  static defaultProps = { delay: 300 }

  scheduleTimer = fn => {
    this.cancelTimer()
    this.timer = setTimeout(fn, this.props.delay)
  }

  cancelTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  componentWillUnmount() {
    this.cancelTimer()
  }

  render() {
    return this.props.children(this.scheduleTimer)
  }
}

export default Debounce



// WEBPACK FOOTER //
// ./src/components/Debounce.js